import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addMedia } from 'slice/mediaSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Add = () => {
  const [formData, setFormData] = useState({
    title: '',
    url: ''
  });

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.media || {});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      dispatch(addMedia(formData));
      toast.success('Video added successfully!');
      navigate('/media');
      setFormData({ title: '', url: '' });
    } catch (error) {
      console.error('Error adding media:', error.message);
    }
  };

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Add Video</h4>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="row mx-4">
            <div className="col-sm-12 mt-2">
              <label htmlFor="title" className="adminlables">
                Title
              </label>
              <input type="text" id="title" name="title" value={formData.title} className="form-control" onChange={handleChange} required />
            </div>

            <div className="col-sm-12 mt-4">
              <label htmlFor="url" className="adminlables">
                Video URL
              </label>
              <input type="text" id="url" name="url" value={formData.url} className="form-control" onChange={handleChange} required />
            </div>
          </div>

          <div className="mt-4 text-right mx-5">
            <button className="btn addbtn btn-lg" disabled={loading}>
              Add Video
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Add;
